<i18n>
{
  "fr": {
    "legend-title": "Légende"
  },
  "de": {

  }
}
</i18n>

<template>
  <div class="tool" id="legend" v-if="show">
    <h3 v-html="legendName"></h3>
    <div class="legend-wrapper">
      <span class="legend-tooltip" v-for="legendTooltip in legendTooltips" :key="legendTooltip.top" :style="{ top: legendTooltip.top, left: legendTooltip.left }">
        <md-tooltip md-direction="left">{{ legendTooltip.content[$i18n.locale] }}</md-tooltip>
      </span>
      <img class="legend" :src="legendUrl" />
    </div>
  </div>
</template>

<script>

import LayerStoreMixin from '@/mixins/store/layer'
import MapStoreMixin from '@/mixins/store/map'

import Config from '@/config.js'

export default {
  name: 'LegendInfo',
  mixins: [
    LayerStoreMixin,
    MapStoreMixin
  ],
  props: {
    params: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return  {

    }
  },
  computed: {
    show () {
      if (this.params.hideWhenGeomSelected) return this.currentGeom === null
      return true
    },
    layer () {
      return this.selectedLayers[0]
    },
    legendUrl () {
      switch(this.params.source) {
        case 'wms':
          return `${this.layer.getSource().getLegendUrl()}&sld_version=1.1.0`
        case 'url':
        default:
          return `${Config.legendBaseUrl}/${this.$i18n.locale}/${this.layer.sourceId}.png`
      }
    },
    legendName () {
      if (typeof this.params.legendName === 'undefined') return this.$t('legend-title')
      else return this.params.legendName[this.$i18n.locale]
    },
    legendTooltips () {
      if (typeof this.params.legendTooltips === 'undefined') return []
      return this.params.legendTooltips
    }
  },
  methods: {
    handleError (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  .wide #legend {
    width: calc(33% - 5px);
    margin-right: 5px;
  }

  .legend-wrapper {
    position: relative;
    .legend-tooltip {
      position: absolute;
      width: 25px;
      height: 25px;
      display: block;
    }
  }
</style>
